import React, { ReactNode, MouseEvent } from 'react';
import { FaCheck } from 'react-icons/fa';

export interface CheckboxProps {
	id: string;
	name?: string;
	checked: boolean;
	children?: ReactNode;
	disabled?: boolean;
	focused?: boolean;
	onChange(checked: boolean, event: MouseEvent<HTMLLabelElement>): void;
}

export function Checkbox({ id, name, checked, children, disabled, focused, onChange }: CheckboxProps) {
	const handleChange = (e: MouseEvent<HTMLLabelElement>) => {
		e.preventDefault();
		onChange(!checked, e);
	};

	return (
		<label
			htmlFor={id}
			className={`relative inline-block w-[22px] h-[22px] pl-[22px] align-top ${
				disabled ? 'pointer-events-none' : 'cursor-pointer'
			}`}
			onClick={handleChange}
		>
			<input
				className='absolute left-1 top-1'
				disabled={disabled}
				checked={checked}
				id={id}
				name={name}
				type='checkbox'
				onChange={() => null}
			/>
			<span
				className={`absolute left-0 top-0 w-full h-full border-2 rounded border-cPurple-800 text-white bg-white transition ${
					focused ? 'ring-4 ring-gray-200' : 'hover:border-black'
				} ${disabled ? '!border-gray-300 !bg-gray-100' : ''} ${checked ? '!bg-cPurple-800' : ''}`}
			>
				<FaCheck
					className={`block absolute left-1/2 top-1/2 w-3 h-3 -mt-1.5 -ml-1.5 transition ${
						checked ? 'scale-100 opacity-100' : 'scale-50 opacity-0'
					}`}
					data-testid='checkbox'
				/>
			</span>
			{children}
		</label>
	);
}
